import React from 'react';
import { Link } from 'react-router-dom';
import '../../assets/css/components/access_denied.css';
import { Security } from '../../assets/icons';

const AccessDenied = () => {
    return (
        <div className="access-denied">
            <img src={Security} alt="Access Denied" className="lock-icon" />
            <h1>Access Restricted</h1>
            <p>Please log in to access this feature</p>
            <div className="auth-actions">
                <Link to="/login" className="btn-primary">
                    Login
                </Link>
                <Link to="/register" className="btn-secondary">
                    Create Account
                </Link>
            </div>
        </div>
    );
};

export default AccessDenied;